<template>
	<div>
		<Selector v-model:internet="internet" v-model:phone="phone" v-model:tv="tv" />
		<SectionTitle title="Тарифы для города"></SectionTitle>
		<Section :tarifes="tarifes.city" :internet="internet" :phone="phone" :tv="tv" @connect="showModal"></Section>
		<SectionTitle title="Тарифы для частного сектора"></SectionTitle>
		<Section :tarifes="tarifes.country" :internet="internet" :phone="phone" :tv="tv" @connect="showModal"></Section>
		<modal-form :active="activeModal" :tarif="currentTarif" @close="closeModal"></modal-form>


	</div>
</template>

<script>
import Selector from './main/Selector';
import Section from './main/Section';
import SectionTitle from "@/main/SectionTitle";
import ModalForm from './main/ModalForm.vue';

export default {
	name: 'App',
	components: {
		Selector, Section, SectionTitle, ModalForm
	},
	props: {
		tarifes: Object
	},
	data() {
		return {
			internet: true,
			phone: false,
			tv: false,
			activeModal: false,
			currentTarif: Object
		}
	},
	methods: {
		showModal(e) {
			this.activeModal = true;
			this.currentTarif = e;
		},
		closeModal() {
			this.activeModal = false;
		}
	}
}
</script>